export default {
      id: "head-left-usage",
      viewBox: "0 0 26 41",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#head-left",
      toString: function () {
        return this.url;
      }
    }